module.exports = __webpack_public_path__ + "media/images/www/guide/good_bad/good/organize_bags-22cb2a9de548fb3d076487bf38015bbc.png";